import * as React from 'react'

import { cn } from '@/lib/utils'
import { LucideIcon } from 'lucide-react'

function Input({
  className,
  type,
  ...props
}: React.ComponentProps<'input'> & {
  startIcon?: LucideIcon
  endIcon?: LucideIcon | React.ReactNode
}) {
  const StartIcon = props.startIcon
  const EndIcon = props.endIcon
  return (
    <div className='relative w-full'>
      {StartIcon && (
        <div className='absolute top-1/2 left-1.5 -translate-y-1/2 transform'>
          <StartIcon size={16} className='text-muted-foreground' />
        </div>
      )}
      <input
        type={type}
        data-slot='input'
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          props.startIcon ? 'pl-6' : '',
          props.endIcon ? 'pr-6' : '',
          className
        )}
        {...props}
      />
      {EndIcon && (
        <div className='absolute top-1/2 right-3 -translate-y-1/2 transform'>
          {typeof EndIcon === 'function' ? (
            <EndIcon size={18} className='text-muted-foreground' />
          ) : (
            EndIcon
          )}
        </div>
      )}
    </div>
  )
}

export { Input }
